import React, {useState} from "react";
import { FaFacebook, FaTwitter, FaGooglePlus, FaLinkedin } from "react-icons/fa";
import { BiPlusMedical } from "react-icons/bi";
import './CircularMenu.css'

const CircularMenu = () => {
    const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };
  return (
    <div className={`circular-menu ${isActive ? "active" : ""}`}>
      <a className="floating-btn" onClick={toggleMenu}>
        <BiPlusMedical className="icon" />
      </a>

      <menu className="items-wrapper">
        <a href="#" className="menu-item">
          <FaFacebook />
        </a>
        <a href="#" className="menu-item">
          <FaTwitter />
        </a>
        <a href="#" className="menu-item">
          <FaGooglePlus />
        </a>
        <a href="#" className="menu-item">
          <FaLinkedin />
        </a>
      </menu>
    </div>
  );
};

export default CircularMenu;
